import PortfolioSlider from './components/PortfolioSlider.svelte'
import Testimonials from './components/testimonials.svelte'

document.addEventListener('DOMContentLoaded', function () {
	var theme = window.aubuchonTheme || {}
	var scheduleIdleTask =
		theme.scheduleIdleTask ||
		(window.requestIdleCallback
			? function (callback) {
					return window.requestIdleCallback(callback, { timeout: 500 })
			  }
			: function (callback) {
					return window.setTimeout(callback, 1)
			  })
	var scheduleNextPaint =
		theme.scheduleNextPaint ||
		(window.requestAnimationFrame
			? function (callback) {
					return window.requestAnimationFrame(callback)
			  }
			: function (callback) {
					return window.setTimeout(callback, 16)
			  })

	if (!document.body.classList.contains('home')) {
		return
	}

	homePage()

	function homePage() {
		var homeMapAssets = theme.homeMapAssets || {}
		var wordElements = Array.prototype.slice.call(document.querySelectorAll('em > span'))
		var slideElements = Array.prototype.slice.call(document.querySelectorAll('.slide'))
		var wordAnimationDuration = 700
		var wordCount = wordElements.length
		var slideCount = slideElements.length
		var activeWordIndex = getActiveIndex(wordElements)
		var activeSlideIndex = getActiveIndex(slideElements)
		var wordResetTimer = null

		var testimonialEl = document.getElementById('testi-slider')
		if (testimonialEl && testimonialEl.dataset.testimonials) {
			scheduleIdleTask(function () {
				new Testimonials({
					target: testimonialEl,
					props: {
						data: JSON.parse(testimonialEl.dataset.testimonials),
					},
				})
			})
		}

		var mapEl = document.getElementById('svelte-map')
		if (mapEl && mapEl.dataset.coordinates) {
			setupLazyHomeMap(mapEl)
		}

		var portfolioSliderEl = document.getElementById('svelte-portfolio-slider')
		if (portfolioSliderEl && portfolioSliderEl.dataset.projects) {
			scheduleNextPaint(function () {
				try {
					new PortfolioSlider({
						target: portfolioSliderEl,
						props: {
							data: JSON.parse(portfolioSliderEl.dataset.projects),
						},
					})
				} catch (e) {
					console.error('Error parsing projects data or mounting PortfolioSlider:', e)
				}
			})
		}

		if (!wordCount && !slideCount) {
			return
		}

		syncActiveState(wordElements, activeWordIndex)
		syncActiveState(slideElements, activeSlideIndex)

		function nextWord() {
			var currentWord
			var nextWord

			if (!wordCount) {
				return
			}

			currentWord = wordElements[activeWordIndex]
			activeWordIndex = getNextIndex(activeWordIndex, wordCount)
			nextWord = wordElements[activeWordIndex]

			if (wordResetTimer) {
				window.clearTimeout(wordResetTimer)
			}

			scheduleNextPaint(function () {
				currentWord.classList.add('fade-out')
				nextWord.classList.remove('fade-out', 'fade-in')
				nextWord.classList.add('active')
			})

			wordResetTimer = window.setTimeout(function () {
				for (var wordIndex = 0; wordIndex < wordCount; wordIndex += 1) {
					if (wordIndex !== activeWordIndex) {
						wordElements[wordIndex].classList.remove('active', 'fade-out', 'fade-in')
					}
				}
			}, wordAnimationDuration)
		}

		function nextSlide() {
			var currentSlide
			var nextSlideElement

			if (!slideCount) {
				return
			}

			currentSlide = slideElements[activeSlideIndex]
			activeSlideIndex = getNextIndex(activeSlideIndex, slideCount)
			nextSlideElement = slideElements[activeSlideIndex]

			scheduleNextPaint(function () {
				currentSlide.classList.remove('active')
				nextSlideElement.classList.add('active')
			})
		}

		setInterval(function () {
			nextWord()
			nextSlide()
		}, 3500)

		function getActiveIndex(elements) {
			var elementIndex

			for (elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
				if (elements[elementIndex].classList.contains('active')) {
					return elementIndex
				}
			}

			return 0
		}

		function getNextIndex(currentIndex, total) {
			if (!total) {
				return 0
			}

			return (currentIndex + 1) % total
		}

		function syncActiveState(elements, activeIndex) {
			var elementIndex

			for (elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
				elements[elementIndex].classList.toggle('active', elementIndex === activeIndex)
			}
		}

		function setupLazyHomeMap(mapElement) {
			if (!homeMapAssets.scriptUrl || mapElement.dataset.mapReady === 'true') {
				return
			}

			if ('IntersectionObserver' in window) {
				var observer = new IntersectionObserver(
					function (entries) {
						var entry = entries[0]

						if (!entry || !entry.isIntersecting) {
							return
						}

						observer.disconnect()
						loadHomeMapAssets(mapElement)
					},
					{ rootMargin: '200px 0px' }
				)

				observer.observe(mapElement)
				return
			}

			loadHomeMapAssets(mapElement)
		}

		function loadHomeMapAssets(mapElement) {
			if (mapElement.dataset.mapReady === 'true') {
				return
			}

			mapElement.dataset.mapReady = 'true'

			if (homeMapAssets.styleUrl && !document.querySelector('link[data-home-map-style="true"]')) {
				var stylesheet = document.createElement('link')
				stylesheet.rel = 'stylesheet'
				stylesheet.href = homeMapAssets.styleUrl
				stylesheet.dataset.homeMapStyle = 'true'
				document.head.appendChild(stylesheet)
			}

			scheduleIdleTask(function () {
				if (document.querySelector('script[data-home-map-script="true"]')) {
					return
				}

				var script = document.createElement('script')
				script.src = homeMapAssets.scriptUrl
				script.async = true
				script.dataset.homeMapScript = 'true'
				document.body.appendChild(script)
			})
		}
	}
})